import React from 'react'
import { UserRole, useAuth } from '@modmd/data'
import Button from 'components/Button'
import { Text } from 'components/Typography'

export interface Props {
  onClick?: () => void
}

export const AddStaffVerifier: React.VFC<Props> = ({ onClick }) => {
  const { hasRoles } = useAuth()
  const isNurseOrSuperAdminOrResult = hasRoles([
    UserRole.NURSE,
    UserRole.SUPER_ADMIN,
    UserRole.ADMIN,
    UserRole.RESULTS,
  ])

  const ButtonAllow = () => {
    if (isNurseOrSuperAdminOrResult) {
      return <Button onClick={onClick}>Review</Button>
    }
    return <Text>On review</Text>
  }

  return <ButtonAllow />
}
